import { sessionExpired } from "./session-guard.js";
export const recoveryMarker = "cc-session-recovery";
const recordKey = "session:recovery";
// Only the random generation marker is plaintext. Session material uses the
// existing encrypted store. Neither restart nor recovery renews server expiry.
export function sessionRecovery(storage, records, now = Date.now, id = () => crypto.randomUUID()) {
    const eligible = (s) => !!s?.actor?.id &&
        s.purpose === "full" && s.actor.role !== "admin" && !sessionExpired(s.expiresAt, now());
    return {
        blocked: () => storage.getItem(recoveryMarker)?.startsWith("locked:") ?? false,
        lock() { storage.setItem(recoveryMarker, "locked:" + id()); },
        async remember(session) {
            const generation = id();
            storage.setItem(recoveryMarker, "locked:" + generation);
            if (!eligible(session)) {
                storage.setItem(recoveryMarker, "online:" + generation);
                return;
            }
            await records.put(recordKey, { generation, session });
            // A concurrent sign-out/login must win over an earlier pending write.
            if (storage.getItem(recoveryMarker) === "locked:" + generation)
                storage.setItem(recoveryMarker, generation);
        },
        async restore() {
            const generation = storage.getItem(recoveryMarker);
            if (!generation || generation.startsWith("locked:"))
                return null;
            const saved = await records.get(recordKey);
            if (storage.getItem(recoveryMarker) !== generation || saved?.generation !== generation ||
                !eligible(saved?.session))
                return null;
            return saved.session;
        },
    };
}
